import { titleCase } from './SqliteHelp.js'
export function makeControllersCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    return makeCode(tableName,tableDatas)
}

export function makeCode(tableName,tableDatas) {
  let searchStr = `
  /// 查询参数集
  Map paramsForm = {
    // "pageSize": 10,
    // "pageNum": 1,
    "search" : null,
    "id": null,`
  tableDatas[tableName].forEach(tableItem => {
    if (tableItem.name != 'id' && tableItem.searchTyp != 'none' && tableItem.searchTyp != null) {
      searchStr = searchStr + `
    "${tableItem.name}": null,`
    }
  })
  searchStr = searchStr + `
  };`

  let dataForm = `
  /// 数据表单
  Map dataForm = {`
  tableDatas[tableName].forEach(tableItem => {
    dataForm = dataForm + `
    "${tableItem.name}": null,`
  })
  dataForm = dataForm + `
  };`

  let cleanDataForm = `
  /// 数据表单
  Map cleanDataForm = {`
  tableDatas[tableName].forEach(tableItem => {
    cleanDataForm = cleanDataForm + `
    "${tableItem.name}": null,`
  })
  cleanDataForm = cleanDataForm + `
  };`

  return `/// Author: Samle
import 'dart:convert';
import 'package:flutter/material.dart';
import 'package:fluttertoast/fluttertoast.dart';
import 'package:get/get.dart';
import 'dart:convert' as convert;
import '../../../routes/app_pages.dart'; /// lib/app/routes/app_pages.dart
import '../../../../db/db_helper.dart';
import '../../../../store/page_store.dart';

class ${titleCase(tableName)}Controller extends GetxController with StateMixin<List> {
  RxList ${tableName}List = [].obs;
  GlobalKey<FormState> ${tableName}Key = GlobalKey<FormState>();
  TextEditingController search = TextEditingController();
  /// 引入状态管理
  PageStore _pageStore = PageStore();
  /// 获取缓存数据
  getStoreData() async {
    paramsForm = await _pageStore.get${titleCase(tableName)}ParamsForm();
    dataForm = await _pageStore.get${titleCase(tableName)}DataForm();
  }
  ${searchStr}

  /// 获取 ${titleCase(tableName)} 数据集
  get${titleCase(tableName)}List() async {
    /// 传入查询参数 <其他参数按需传入>
    paramsForm["search"] = search.text;
    // paramsForm["pageSize"] = 10;
    // paramsForm["pageNum"] = 1;
    /// 将查询参数集存储到状态管理中
    await _pageStore.set${titleCase(tableName)}ParamsForm(paramsForm);
    /// 进行查询
    ${tableName}List.value = await localData.get${titleCase(tableName)}BySearch(paramsForm);
    change(${tableName}List, status: RxStatus.success());

    // ${tableName}List.value = await localData.get${titleCase(tableName)}();
    // change(${tableName}List, status: RxStatus.success());
  }
  /// 获取 ${titleCase(tableName)} 数据集分页
  Future<void> get${titleCase(tableName)}ListMore() async {
    paramsForm["search"] = search.text;
    paramsForm["pageSize"] = 10;
    paramsForm["pageNum"] = paramsForm["pageNum"] + 1;
    /// 进行查询
    var moreValue = await localData.get${titleCase(tableName)}BySearch(paramsForm);
    if (moreValue.isNotEmpty) {
      ${tableName}List.value.addAll(moreValue);
      change(${tableName}List, status: RxStatus.success());
    } else {
      if (paramsForm["pageNum"] > 1) {
        paramsForm["pageNum"] = paramsForm["pageNum"] - 1;
      }
      Fluttertoast.showToast(
        msg: "已经到底了！",
        toastLength: Toast.LENGTH_SHORT,
        gravity: ToastGravity.BOTTOM,
        backgroundColor: Colors.black12,
        textColor: Colors.black54,
        fontSize: 16.0,
      );
    }
  }
  ${dataForm}

  /// 跳转编辑界面 按需要修改路由
  toEditPage() {
    Get.toNamed('/edit-${tableName}', arguments: dataForm)?.then((value) async {
      if (value == null) { return; } else {
        if (value.containsKey("id") && value['id'] != null && value['id'] != ''){
          dataForm = value;
          update${titleCase(tableName)}();
        } else {
          dataForm = value;
          add${titleCase(tableName)}();
        }
      }
    });
  }

  /// 修改 ${titleCase(tableName)} 实例
  update${titleCase(tableName)}() async {
    /// 更新 dataForm 数据
    /// dataForm = newDataForm;
    /// 将表单数据存储到状态管理中
    await _pageStore.set${titleCase(tableName)}DataForm(dataForm);
    try {
      var result = await localData.update${titleCase(tableName)}(dataForm);
      /// Get.back(result: true); // 更新成功后回调 
      dataForm = cleanDataForm;
      await _pageStore.set${titleCase(tableName)}DataForm(dataForm);
      Fluttertoast.showToast(
        msg: "更新成功！",
        toastLength: Toast.LENGTH_SHORT,
        gravity: ToastGravity.BOTTOM,
        backgroundColor: Colors.green,
        textColor: Colors.white,
        fontSize: 16.0,
      );
      onInit();
    } catch (e) {
      /// 更新失败后回调 
      Fluttertoast.showToast(
        msg: "更新失败！",
        toastLength: Toast.LENGTH_SHORT,
        gravity: ToastGravity.BOTTOM,
        backgroundColor: Colors.red,
        textColor: Colors.white,
        fontSize: 16.0,
      );
    }
  }

  /// 新增 ${titleCase(tableName)} 实例
  add${titleCase(tableName)}() async {
    /// 更新 dataForm 数据
    /// dataForm = newDataForm;
    /// 将表单数据存储到状态管理中
    await _pageStore.set${titleCase(tableName)}DataForm(dataForm);
    try {
      var result = await localData.add${titleCase(tableName)}(dataForm);
      /// Get.back(result: true); // 新增成功后回调
      dataForm = cleanDataForm;
      await _pageStore.set${titleCase(tableName)}DataForm(dataForm);
      Fluttertoast.showToast(
        msg: "新增成功！",
        toastLength: Toast.LENGTH_SHORT,
        gravity: ToastGravity.BOTTOM,
        backgroundColor: Colors.green,
        textColor: Colors.white,
        fontSize: 16.0,
      );
      onInit();
    } catch (e) {
      /// 新增失败后回调 
      Fluttertoast.showToast(
        msg: "新增失败！",
        toastLength: Toast.LENGTH_SHORT,
        gravity: ToastGravity.BOTTOM,
        backgroundColor: Colors.red,
        textColor: Colors.white,
        fontSize: 16.0,
      );
    }
  }
  ${cleanDataForm}

  /// 删除 ${titleCase(tableName)} 实例
  del${titleCase(tableName)}(form) async {
    if (form.containsKey("id") && form["id"] != ""){
      try {
        var result = await localData.delete${titleCase(tableName)}(form["id"]);
        /// Get.back(result: true); // 删除成功后回调 
        Fluttertoast.showToast(
          msg: "删除成功！",
          toastLength: Toast.LENGTH_SHORT,
          gravity: ToastGravity.BOTTOM,
          backgroundColor: Colors.green,
          textColor: Colors.white,
          fontSize: 16.0,
        );
        onInit();
      } catch (e) {
        /// 删除失败后回调 
        Fluttertoast.showToast(
          msg: "删除失败！",
          toastLength: Toast.LENGTH_SHORT,
          gravity: ToastGravity.BOTTOM,
          backgroundColor: Colors.red,
          textColor: Colors.white,
          fontSize: 16.0,
        );
      }
    }
  }

  @override
  Future<void> onInit() async {
    await getStoreData();
    await get${titleCase(tableName)}List();
    super.onInit();
  }

  @override
  void onReady() {
    super.onReady();
  }

  @override
  void onClose() {
    super.onClose();
  }
}
`
}